(() => {
  if (window.akbarDiaryPlaybackLoaded) return;
  window.akbarDiaryPlaybackLoaded = true;

  function bind(wrapper) {
    if (wrapper.dataset.playbackBound) return;
    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('.video-play-btn');
    if (!video || !button) return;
    wrapper.dataset.playbackBound = 'true';
    let frameRequest;
    const reveal = () => {
      if (video.paused) return;
      wrapper.dataset.frameReady = 'true';
      button.classList.add('hidden');
    };
    const reset = () => {
      if (frameRequest !== undefined) video.cancelVideoFrameCallback(frameRequest);
      button.classList.remove('hidden');
    };
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      wrapper.closest('[id^="gallery-"]').querySelectorAll('video').forEach(other => {
        if (other !== video) other.pause();
      });
      if (video.requestVideoFrameCallback) frameRequest = video.requestVideoFrameCallback(reveal);
      video.play().catch(reset);
    });
    // Older browsers lack frame callbacks; wait for decoded playback before revealing.
    video.addEventListener('playing', () => {
      if (!video.requestVideoFrameCallback) requestAnimationFrame(() => requestAnimationFrame(reveal));
    });
    video.addEventListener('click', () => { if (!video.paused) video.pause(); });
    ['pause', 'ended', 'error'].forEach(event => video.addEventListener(event, reset));
  }

  const initialize = () => document.querySelectorAll('[id^="gallery-"] .video-wrapper').forEach(bind);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
